import axios from "axios";
import config from "@Config/index";
import setCookie from "helpers/setCookie";
import getCookie from "helpers/getCookie";

let userCountryPromise: Promise<any> | null = null;

const getUserCountry = async () => {
  try {
    const existingCookie = getCookie("userCountry");
    if (existingCookie) {
      return { country: existingCookie };
    }

    if (userCountryPromise) {
      return userCountryPromise;
    }

    userCountryPromise = (async () => {
      const rawOrigin =
        typeof window !== "undefined" ? window.location.origin : config.WEB_SERVICE_URL;
      const origin = rawOrigin?.endsWith("/") ? rawOrigin.slice(0, -1) : rawOrigin;
      const res = await axios.get(`${origin || ""}/places/getCountryData`, {
        timeout: 5000,
        headers: {
          Accept: "application/json",
        },
      });
      const { data } = res;
      // Set the cookie for one day (1 day)
      setCookie({ cname: "userCountry", cvalue: data.country, exdays: 1 });
      // Store city in localStorage if available
      if (typeof window !== "undefined" && data.city) {
        localStorage.setItem("city", data.city);
      }
      return data;
    })();

    const result = await userCountryPromise;
    return result;
  } catch (error) {
    userCountryPromise = null;
    if (
      typeof window !== "undefined" &&
      typeof window.Sentry !== "undefined" &&
      window.Sentry.captureException
    ) {
      window.Sentry.captureException("Error fetching user country:", error);
    }
    return { country: "GB" };
  }
};

export const getTrustpilotData = async (
  destination_city: any,
  nationality: any,
  university = null,
  cancelToken?: any,
) => {
  try {
    const queryParams = {
      destination_city,
      nationality,
      university,
      limit: 20,
    };
    const { data } = await axios.get(`${config.API_URL}/api/v0/inventories/trustpilot_data`, {
      params: queryParams,
      cancelToken,
    });
    return data?.data;
  } catch (error: any) {
    return { error };
  }
};

export default getUserCountry;
